/* eslint-disable */
import { ChevronDown, ChevronLeft } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import PlaceOrderBg from '../../assets/images/PlaceOrderBg.png'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../Components/ui/tabs'
import { Label } from '../../Components/ui/label'
import { Input } from '../../Components/ui/input'
import { Button } from '../../Components/ui/button'
import { toCurrency } from '../../utils/CurrencyUtil'
import { useModal } from '../../hooks/use-modal-store'
import env from '../../env/env'
import { post } from '../../http/restservice'
import { userDetailsState } from '../LoginState'
import { useRecoilState } from 'recoil'
import { addMonth, formatIndianNumber } from '../../utils/Util'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import { getUserDetails } from '../../utils/AuthUtil'
import { BASKET_ONE_TIME_MIN } from '../../constants/oneTime'


const AdminPlaceOrder = () => {
  let location = useLocation()

  const navigate = useNavigate()

  const [sipAmount] = useState(location?.state?.basketPayload?.sipInvestmentAmount)
  const [lumpsumAmount] = useState(location?.state?.basketPayload?.oneTimeInvestmentAmount)


  const sipInvestmentBreakdown = location?.state?.basketPayload?.sipInvestmentBreakdown
  const basketMinAmount = BASKET_ONE_TIME_MIN[Number(location?.state?.basketPayload?.universalBasketId)]
  const isLessThenBasketMin =
    location?.state?.basketPayload?.oneTimeInvestmentAmount < basketMinAmount
  const oneTimeInvestmentBreakdown = isLessThenBasketMin
    ? (() => {
      const relevantFunds = location?.state?.basketPayload?.oneTimeInvestmentBreakdown

      const fallbackFund = relevantFunds?.find(
        (fund) => fund?.bseSchemeCode?.toLowerCase() === 'cmfcgp-gr',
      )

      return fallbackFund
        ? [
          {
            ...fallbackFund,
            investmentAmount: lumpsumAmount,
            weightage: 100,
            weightageOneTime: 100,
          },
        ]
        : []
    })()
    : location?.state?.basketPayload?.oneTimeInvestmentBreakdown?.filter(
      (item) => item.investmentAmount > 0,
    )

  const [basket] = useState(location?.state?.basketPayload)
  const { showError } = useErrorPopup()
  const { onOpen } = useModal()
  const [tabValue, setTabValue] = useState(location?.state?.sipOrOneTime || 'SIP')
  const [selectedDay, setSelectedDay] = useState(5)
  const [isSIPLoading, setIsSIPLoading] = useState(false)
  const [isOneTimeLoading, setIsOneTimeLoading] = useState(false)
  const [userDetails, setUserDetails] = useRecoilState(userDetailsState)

  const [sipDate, setSipDate] = useState('')

  const currentDate = new Date()
  const today = currentDate.getDate()
  const nextDay1 = new Date()
  nextDay1.setDate(today + 1)
  const nextDay2 = new Date()
  nextDay2.setDate(today + 2)

  useEffect(() => {
    setUserDetails(getUserDetails())
  }, [])

  useEffect(() => {
    const res = addMonth(today, selectedDay)
    setSipDate(res)
  }, [selectedDay, today])

  const createPlan = async () => {
    let { basketPayload, payload: planPayload } = location?.state || {}
    basketPayload.oneTimeInvestmentBreakdown = oneTimeInvestmentBreakdown

    try {
      const basketUrl = `${env.API_URL}adminservice/api/actionPlan/createOrUpdateMFBasket`

      const basketResponse = await post(basketUrl, {
        ...basketPayload,
        phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
      })

      if (basketResponse?.isError) {
        return showError(
          'Plan Creation Failed',
          'We encountered an issue while creating your plan. Please try again later.',
          () => { },
        )
      }

      const basketData = JSON.parse(basketResponse.data)
      const investmentId = basketData?.data?.customerBasketInvestmentId

      if (!investmentId) {
        return showError(
          'Invalid Basket Response',
          'Unable to retrieve the basket investment ID.',
          () => { },
        )
      }

      planPayload.request.customerMfBasketInvestmentId = investmentId

      const planUrl = `${env.API_URL}adminservice/api/actionPlan/createPlan`

      const planResponse = await post(
        planUrl,
        planPayload,
        { 'plan-type': location?.state?.planType },
        { customerId: location?.state?.customerId },
      )

      if (planResponse?.status === 'SUCCESS') {
        onOpen('openAdminPopup', {
          title: 'Plan Created Successfully',
          message:
            'Your plan has been created successfully. You can now proceed with your investments.',
          severity: 'success',
        })
      }

      if (planResponse?.isError) {
        return showError(
          'Plan Creation Failed',
          'We encountered an issue while creating your plan. Please try again later.',
          () => { },
        )
      }
    } catch (error) {
      console.log('🚀 ~ createPlan ~ error:', error)
      showError('Unexpected Error', 'Something went wrong. Please try again later.', () => { })
      console.error('Plan creation error:', error)
    }
  }

  return (
    <>
      <div className='bg-white fabits-order-page'>
        <div className='max-w-[1128px] mx-auto min-h-screen pb-12 fabits-order-shell'>
          <div
            className='flex gap-x-1 items-center font-semibold cursor-pointer lg:py-2.5 p-4 lg:px-0 fabits-order-header'
            onClick={() => navigate(-1)}
          >
            <ChevronLeft className='h-5 w-5' />
            Place Order
          </div>

          <div className='max-w-[360px] mx-auto h-full flex flex-col gap-y-12 justify-between fabits-order-panel'>
            <div className='h-[170px] w-full bg-cover flex justify-center items-center p-2 z-0 relative fabits-order-ticket'>
              <div
                className='absolute inset-0 bg-cover w-full h-full fabits-order-ticket-bg'
                style={{ backgroundImage: `url(${PlaceOrderBg})` }}
              />
              <div
                className='absolute inset-0 fabits-order-ticket-wash'
                style={{
                  background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
                }}
              />
              <div className='flex items-center space-x-4 z-10 fabits-order-ticket-content'>
                <img
                  src={`${env.SVGS}/basket.svg`}
                  alt={basket?.customerBasketName}
                  className='w-12 h-12 border rounded-lg fabits-order-fund-logo'
                />
                <div>
                  <h3
                    className='font-semibold text-sm leading-tight text-wrap w-48 fabits-order-fund-name'
                    style={{ textWrap: 'pretty' }}
                  >
                    {basket?.customerBasketName}
                  </h3>
                </div>
              </div>
            </div>

            <Tabs
              defaultValue='SIP'
              value={tabValue}
              onValueChange={setTabValue}
              className='fabits-order-tabs'
            >
              <TabsList className='mx-auto grid h-12 w-full grid-cols-2 rounded-[999px]'>
                <TabsTrigger
                  className='h-10 px-2 font-IBM text-sm leading-5'
                  value='SIP'
                  disabled={sipAmount == 0 || location?.state?.isSubsequentOneTimeOrder}
                >
                  <span className='truncate'>SIP</span>
                </TabsTrigger>

                <TabsTrigger
                  className='h-10 px-2 font-IBM text-sm leading-5'
                  value='One-Time'
                  disabled={lumpsumAmount == 0}
                >
                  <span className='truncate'>One-Time</span>
                </TabsTrigger>
              </TabsList>

              <div>
                <TabsContent value='SIP'>
                  <div className='flex flex-col justify-center items-center gap-1.5 mt-12 fabits-order-amount-block'>
                    <Label htmlFor='amount' className='text-black-400 text-xs fabits-order-label'>
                      Investment amount
                    </Label>
                    <Input
                      disabled
                      id='amount'
                      placeholder='Amount'
                      className='border-none outline-none text-center font-DMSans font-semibold text-3xl mx-auto fabits-order-amount-input'
                      value={`₹ ${toCurrency(sipAmount)}`}
                    />
                  </div>

                  <div className='my-6 flex justify-center'>
                    <Button
                      variant='link'
                      size='simple'
                      className='text-primary-500 p-0 border-b border-dashed border-primary-500 rounded-none hover:no-underline'
                      onClick={() =>
                        onOpen('openMFBreakdown', {
                          constituents: sipInvestmentBreakdown
                            ?.map((fund) => ({
                              ...fund,
                              weightage: fund?.weightage,
                            }))
                            .filter((fund) => fund?.weightage != 0),

                          amount: sipAmount,
                        })
                      }
                    >
                      View detailed breakdown
                      <ChevronDown className='h-4 w-4 ml-1' />
                    </Button>
                  </div>

                  <div className='flex gap-x-2 mt-6'>
                    <Button
                      className='rounded-xl flex-1 disabled:bg-primary-300 fabits-order-primary-action'
                      loading={isSIPLoading}
                      onClick={() => createPlan()}
                    >
                      Create Plan
                    </Button>
                  </div>
                </TabsContent>

                <TabsContent value='One-Time' className='h-full'>
                  <div className='flex flex-col justify-center items-center gap-1.5 mt-12 fabits-order-amount-block'>
                    <Label htmlFor='amount' className='text-black-400 text-xs fabits-order-label'>
                      Investment amount
                    </Label>
                    <Input
                      disabled
                      id='amount'
                      placeholder='Amount'
                      className='border-none outline-none text-center min-w-fit font-DMSans font-semibold text-3xl fabits-order-amount-input'
                      value={`₹ ${toCurrency(lumpsumAmount)}`}
                    />
                  </div>

                  <div className='my-6 flex justify-center'>
                    <Button
                      variant='link'
                      size='simple'
                      className='text-primary-500 p-0 border-b border-dashed border-primary-500 rounded-none hover:no-underline'
                      onClick={() =>
                        onOpen('openMFBreakdown', {
                          constituents: oneTimeInvestmentBreakdown
                            ?.map((fund) => ({
                              ...fund,
                              weightage: fund?.weightageOneTime,
                            }))
                            .filter((fund) => fund.weightageOneTime != 0),
                          amount: lumpsumAmount,
                        })
                      }
                    >
                      View detailed breakdown
                      <ChevronDown className='h-4 w-4 ml-1' />
                    </Button>
                  </div>

                  <div className='mt-12'>
                    <Button
                      className='rounded-xl w-full disabled:bg-primary-300 fabits-order-primary-action'
                      loading={isOneTimeLoading}
                      onClick={() => createPlan()}
                    >
                      Create Plan
                    </Button>
                  </div>
                </TabsContent>
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  )
}

export default AdminPlaceOrder
